// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-selector {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.date-inputs {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.date-input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.date-input-group label {
  font-size: 0.85rem;
  color: #666;
}

.date-input-group input[type="date"] {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
}

.date-presets {
  display: flex;
  gap: 0.5rem;
}

.date-preset-btn {
  padding: 0.4rem 0.8rem;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s;
}

.date-preset-btn:hover {
  background: var(--button-color, #007bff);
  color: white;
  border-color: var(--button-color, #007bff);
}
`, "",{"version":3,"sources":["webpack://./src/components/Consumption/DateRangeSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,0CAA0C;AAC5C","sourcesContent":[".date-range-selector {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.date-inputs {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.date-input-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.date-input-group label {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.date-input-group input[type=\"date\"] {\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.date-presets {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.date-preset-btn {\n  padding: 0.4rem 0.8rem;\n  background: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.date-preset-btn:hover {\n  background: var(--button-color, #007bff);\n  color: white;\n  border-color: var(--button-color, #007bff);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
